// Import statements remain the same
import React, { memo, useEffect, useState } from 'react'
import {
  Card,
  Col,
  Empty,
  message,
  Row,
  Typography,
  Badge,
  Avatar,
  Input,
  Spin,
  Button,
} from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import { useTheme } from '@mui/material'
import MainLayout from '../../../layouts/MainLayout'
import { IoMdSearch } from 'react-icons/io'
import { Filter } from 'iconoir-react'
import InternalMessageLayout from '../../../components/InternalMessageLayout/InternalMessageLayout'
// import './InternalMessageSendPage.css'
import { apiUrl } from '../../../config'
import { subStringAvatar } from '../../../components/common/CellText'
import { AiOutlineSearch } from 'react-icons/ai'
import InternalMessageCreateModal from './InternalMessageCreateModal'
import utils from '../../../utils'

const { Title, Text } = Typography

const formatTime = time => {
  const now = moment()
  const messageTime = moment(time)
  const diffDays = now.diff(messageTime, 'days')
  const diffMonths = now.diff(messageTime, 'months')
  const diffYears = now.diff(messageTime, 'years')

  // if (diffDays === 0) {
  //   return messageTime.format('HH:mm')
  // } else if (diffDays === 1) {
  //   return '1 ngày trước'
  // } else if (diffDays < 7) {
  //   return `${diffDays} ngày trước`
  // } else if (diffDays < 30) {
  //   return `${Math.floor(diffDays / 7)} tuần trước`
  // } else if (diffMonths === 0) {
  //   return `${Math.floor(diffDays / 30)} tháng trước`
  // } else if (diffMonths === 1) {
  //   return '1 tháng trước'
  // } else if (diffMonths < 12) {
  //   return `${diffMonths} tháng trước`
  // } else if (diffYears === 0) {
  //   return `${Math.floor(diffMonths / 12)} năm trước`
  // } else if (diffYears === 1) {
  //   return '1 năm trước'
  // } else {
  // }
  return messageTime.format('DD/MM/YYYY')
}

const InternalMessageSendPage = props => {
  const {
    internalMessageStore,
    loadingAnimationStore,
    userStore,
    authenticationStore,
  } = props
  const {
    internalMessageSendList,
    queryParams,
    internalMessageListTotalCount,
  } = internalMessageStore
  const [hasMore, setHasMore] = useState(true)
  const [pageIndex, setPageIndex] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()
  const [loading, setLoading] = useState(true)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [messagesList, setMessagesList] = useState([])
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    keyword: null,
  })
  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)
      userStore.setFilter('userListStatus', true)
      userStore.setFilter(
        'companyCode',
        authenticationStore.currentCompanyCode()
      )
      userStore
        .getUserListV2()
        .finally(() => loadingAnimationStore.showSpinner(false))
    }
    return () => userStore.clearStore()
  }, [authenticationStore.currentUser])

  const getInternalMessageReceiveList = async () => {
    try {
      const newMessages = await internalMessageStore.getInternalMessageSendList(
        {
          page: pageIndex,
          size: 10,
          ...queryParams,
        }
      )
      if (newMessages.length > 0) {
        setMessagesList(prevMessages => [
          ...prevMessages,
          ...newMessages.map(message => ({
            ...message,
            created_time: formatTime(message.created_time),
          })),
        ])
      } else {
        setHasMore(false)
      }
    } catch (error) {
      message.error('Failed to load messages')
    }
  }

  useEffect(() => {
    setPageIndex(0) // Reset page index when the component mounts
    getInternalMessageReceiveList()

    return () => internalMessageStore.clearMessageStore()
  }, [])
  const toTitleCase = str => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }

  const getInternalMessageSendList = async () => {
    try {
      loadingAnimationStore.setTableLoading(true)

      await internalMessageStore.getInternalMessageSendList(filter)
    } catch (error) {
      // console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.setTableLoading(false)
      // setCheckPagination(true)
    }
  }

  const fetchMoreData = async () => {
    if (internalMessageSendList.length >= internalMessageListTotalCount) {
      setHasMore(false)
      return
    }

    internalMessageStore.setQueryParams({
      ...queryParams,
      page: queryParams.page,
    })

    try {
      const newMessages = await internalMessageStore.getInternalMessageSendList(
        {
          page: queryParams.page,
          size: queryParams.size,
          keyword: queryParams.keyword,
        }
      )

      if (!newMessages.length) {
        setHasMore(false)
      }
    } catch (error) {
      message.error('Failed to load messages')
    }
  }

  const [value, setValue] = useState('')
  const handleQuickSearch = async event => {
    event.preventDefault()
    internalMessageStore.clearInternalMessageList() // Clear old messages
    internalMessageStore.setQueryParams({ page: 0, keyword: value }) // Update keyword and reset page
    try {
      setLoading(true)
      await internalMessageStore.getInternalMessageSendList() // Fetch new list based on updated queryParams
      setLoading(false)
    } catch (err) {
      message.error('Failed to load messages')
    }
  }

  useEffect(() => {
    if (internalMessageSendList.length < internalMessageListTotalCount) {
      setHasMore(true)
      return
    }
  }, [internalMessageSendList, internalMessageListTotalCount])

  const updatedMessages = internalMessageSendList?.map(message => {
    const user = userStore.userWithImageId?.find(
      user => user.username === message.owner
    )
    return user && user.image_id
      ? { ...message, image_id: user.image_id }
      : message
  })

  return (
    <>
      <div
        style={{ backgroundColor: theme.background.base, minHeight: '850px' }}>
        <div
          className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
          style={{
            background: theme.background.header,
            color: theme.color.text1,
          }}>
          <div className="font-bold text-[28px] leading-[29px]">
            Tin nhắn nội bộ
          </div>
          {/* <span className="w-5 cursor-pointer" onClick={() => {}}>
            <Filter />
          </span> */}
        </div>

        <MainLayout initialValue={5} className="mt-[100px]">
          <InternalMessageLayout
            selectedKey="send"
            linkToInternalMessageRecieve="/utility/internal-message/receive"
            linkToInternalMessageSend="/utility/internal-message/send">
            <Button
              variant="contained"
              color="primary"
              style={{
                textTransform: 'none',
                fontSize: '16px',
                color: 'white',
                backgroundColor: '#1976d2',
                margin: '15px 0 15px 15px',
                height: '40px',
              }}
              onClick={() => setIsModalVisible(true)}>
              <span className="mx-4 ">Gửi tin nhắn</span>
            </Button>
            <form onSubmit={handleQuickSearch} className="px-1 pb-2  w-full  ">
              <div
                className="flex items-center bg-[#9d9d9d] rounded-xl"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <input
                  className="py-2 rounded-xl w-full focus-visible:outline-none bg-[#f0f1f3]  border-none"
                  type="text"
                  placeholder="Tìm kiếm"
                  style={{
                    paddingRight: '3rem',
                    paddingLeft: '1rem',
                  }}
                  value={value}
                  onChange={e => setValue(e.target.value)}
                />

                <div className="absolute right-4">
                  <AiOutlineSearch color="#65696e" fontSize={25} />
                </div>
              </div>
            </form>

            <InfiniteScroll
              style={{ padding: 0 }}
              dataLength={internalMessageSendList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 10,
                  }}>
                  {internalMessageSendList.length > 10 ? (
                    <Spin tip="Đang tải..." />
                  ) : (
                    ''
                  )}
                </div>
              }
              endMessage={<Empty description="No more messages" />}>
              <Row
                gutter={[16, 16]}
                style={{ width: '100%', margin: 0, padding: 0 }}>
                {internalMessageSendList?.map(message => (
                  <Col xs={24} sm={12} md={8} lg={6} key={message.code}>
                    <Card
                      // hoverable
                      className="message-card border-none"
                      onClick={() =>
                        navigate(
                          `/utility/internal-message/send/view/${message.code}`
                        )
                      }
                      style={{
                        borderLeft: message.isUnread
                          ? '4px solid #1890ff'
                          : '4px solid transparent',
                        marginBottom: '5px',
                        marginRight: '10px',
                        marginLeft: '10px',
                      }}>
                      <Row align="middle" justify="space-between">
                        <Col>
                          <Badge dot={message.isUnread}>
                            <Avatar
                              style={{
                                backgroundColor: '#2C65AC',
                                fontSize: 12,
                                width: 40,
                                height: 40,
                                marginRight: 10,
                                border: 'none',
                              }}
                              src={
                                message?.receiver?.[0]?.fullname ? (
                                  <div style={{ fontSize: '18px' }}>
                                    {subStringAvatar(
                                      message.receiver[0].fullname
                                    )}
                                  </div>
                                ) : message.owner ? (
                                  <div style={{ fontSize: '18px' }}>
                                    {subStringAvatar(message.owner)}
                                  </div>
                                ) : null
                              }
                              size="large"
                            />
                          </Badge>
                        </Col>
                        <Col flex="auto">
                          <Text
                            type="secondary"
                            style={{
                              fontWeight: message.is_read ? '400' : 'bold',
                              color: '#000',
                            }}
                            className="max-w-[250px] overflow-hidden overflow-ellipsis whitespace-nowrap"
                            ellipsis={{
                              tooltip: message.receiver
                                .map(user =>
                                  utils.getNameInCapitalize(user.fullname)
                                )
                                .join(', '),
                            }}>
                            {message.receiver
                              .map(user =>
                                utils.getNameInCapitalize(user.fullname)
                              )
                              .join(', ')}
                          </Text>
                          <div className="message-preview max-w-[200px]">
                            <Text
                              type="secondary"
                              style={{
                                fontWeight: message.is_read ? '400' : 'bold',
                              }}
                              className="max-w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap"
                              ellipsis={{ tooltip: message.title }}>
                              {message.title}
                            </Text>
                          </div>
                        </Col>
                        <Col>
                          <Text
                            type="secondary"
                            style={{
                              fontSize: '12px',
                              fontWeight: message.is_read ? '400' : 'bold',
                            }}>
                            {formatTime(message.created_time)}
                          </Text>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
              </Row>
            </InfiniteScroll>
          </InternalMessageLayout>
        </MainLayout>
      </div>
      <InternalMessageCreateModal
        isModalVisible={isModalVisible}
        handleCloseCreateModal={isRefressList => {
          setIsModalVisible(false)
          if (isRefressList) {
            getInternalMessageSendList()
          }
        }}
      />
    </>
  )
}

export default memo(
  inject(
    'internalMessageStore',
    'loadingAnimationStore',
    'userStore',
    'authenticationStore'
  )(observer(InternalMessageSendPage))
)
